module.exports = __webpack_public_path__ + "img/1495156910.ef336c76.jpg";